let Translations = {
    fr: {
        close: 'close',
        create: 'create',
        delete: 'delete',
        filter: 'filter'
    },
    en: {
        close: 'close',
        create: 'create',
        delete: 'delete',
        filter: 'filter'
    },
    zh: {
        close: 'close',
        create: 'create',
        delete: 'delete',
        filter: 'filter'
    }
};
export {Translations}